type FrontmatterValue = string | boolean | string[];

export type Frontmatter = Record<string, FrontmatterValue>;

function stripQuotes(value: string) {
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }

  return trimmed;
}

function parseScalar(value: string) {
  const cleanValue = stripQuotes(value);
  if (cleanValue === "true") return true;
  if (cleanValue === "false") return false;
  return cleanValue;
}

export function splitFrontmatter(raw: string) {
  const normalized = raw.replace(/\r\n/g, "\n");
  const match = normalized.match(/^---\n([\s\S]*?)\n---\n?/);

  if (!match) {
    return {
      frontmatter: {},
      body: normalized
    };
  }

  return {
    frontmatter: parseFrontmatterBlock(match[1]),
    body: normalized.slice(match[0].length)
  };
}

export function parseFrontmatterBlock(block: string): Frontmatter {
  const output: Frontmatter = {};
  let activeArrayKey: string | null = null;

  for (const line of block.split("\n")) {
    if (!line.trim()) continue;

    const arrayItem = line.match(/^\s*-\s+(.+)$/);
    if (arrayItem && activeArrayKey) {
      const existing = output[activeArrayKey];
      output[activeArrayKey] = Array.isArray(existing)
        ? [...existing, stripQuotes(arrayItem[1])]
        : [stripQuotes(arrayItem[1])];
      continue;
    }

    const field = line.match(/^([A-Za-z0-9_-]+):\s*(.*)$/);
    if (!field) continue;

    const [, key, rawValue] = field;
    if (rawValue === "") {
      output[key] = [];
      activeArrayKey = key;
      continue;
    }

    output[key] = parseScalar(rawValue);
    activeArrayKey = null;
  }

  return output;
}
